<template>
	<div class="playerWrapper" ref="playerWrapper" @click="playVideo">
		<video 
		ref="videoPlayer"
		class="video-js"
		playsinline="true"
		webkit-playsinline="true"
		></video>
		<div class="playBtn" v-show="playShow">
			<img src="../assets/image/icon/playBtn.png" alt="">
		</div>
	</div>
</template>

<script>
	import videojs from 'video.js'
	import 'video.js/dist/video-js.css'
	export default {
		name: "VideoPlayer",
		props: {
			options: {
				type: Object,
				default(){
					return {}
				}
			}
		},
		watch: {
			options: {
				handler(){
					this.init()
				}
			}
		},
		data(){
			return {
				player: null,
				defaultOptions: {
					autoplay: false,
					controls: false,
					fill: false,
					preload: 'auto',
					controlBar: {
						currentTimeDisplay: true,
						timeDivider: true,
						remainingTimeDisplay: true,
						durationDisplay: false,
						volumePanel: {
							inline: false
						}
					},
					playbackRates: [0.7, 1, 1.5, 2],
					poster: '',
					src: ''
				},
				playShow: true,
			}
		},
		beforeDestroy() {
			if(this.player){
				this.player.dispose()
			}
		},
		methods: {
			init(){
				this.player = videojs(this.$refs.videoPlayer, this.videoOptions(), function onPlayerReady(){
				})
			},
			videoOptions() {
				return Object.assign(this.defaultOptions, {
					width: this.$refs.playerWrapper.offsetWidth,
					height: this.$refs.playerWrapper.offsetWidth * 9 /16
				}, this.options)
			},

			playVideo() {
				const videoElement = this.$el.querySelector('video'); // 获取video元素
				if (videoElement.paused) {
					videoElement.play(); // 播放视频
					this.playShow = false;
				} else {
					videoElement.pause(); // 暂停视频
					this.playShow = true;
				}
			},
		}
	}
</script>

<style scoped>
.playerWrapper{
	width: 100%;
	padding-top: calc(100% / 1.77);
	position: relative;
	/* display: flex;
	justify-content: center;
	align-items: center; */
	background: #d8d8d8 no-repeat;
}
.video-js{
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
.video-js >>> .vjs-big-play-button {
	font-size: 2.5em;
	width: 2.5em;
	height: 2.5em;
	line-height: 2.5em;
	top: 50%;
	left: 50%;
	margin-top: -1.2em;
	margin-left: -1.2em;
	border-radius: 2.5em;
	background-color: rgba(29, 32, 35, 0.5);
	border: none;
}

.playBtn {
	box-sizing: border-box;
	width: 5rem;
	height: 5rem;
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top: -2.5rem;
	margin-left: -2.5rem;
	z-index: 1111;
}

.playBtn img {
	width: 5rem;
	height: 5rem;
}
</style>